export const fields = [
  {
    id: "locationName",
    name: "locationName",
    label: "Location Name",
    type: "string",
  },
  {
    id: "address",
    name: "address",
    label: "Address",
    type: "string",
  },
  {
    id: "address2",
    name: "address2",
    label: "Address 2",
    type: "string",
  },
  {
    id: "city",
    name: "city",
    label: "City",
    type: "string",
  },
  {
    id: "state",
    name: "state",
    label: "State",
    type: "string",
  },
  {
    id: "zipCode",
    name: "zipCode",
    label: "Zip Code",
    type: "string",
  },
  {
    id: "email",
    name: "email",
    label: "Email",
    type: "string",
  },
  {
    id: "phone",
    name: "phone",
    label: "Phone",
    type: "string",
  },
  {
    id: "hoursWeekdays",
    name: "hoursWeekdays",
    label: "Hours Weekdays",
    type: "string",
  },
  {
    id: "hoursSaturday",
    name: "hoursSaturday",
    label: "Hours Saturday",
    type: "string",
  },
  {
    id: "hoursSunday",
    name: "hoursSunday",
    label: "Hours Sunday",
    type: "string",
  },
  {
    id: "gateHours",
    name: "gateHours",
    label: "Gate Hours Weekdays",
    type: "string",
  },
  {
    id: "gateHoursSaturday",
    name: "gateHoursSaturday",
    label: "Gate Hours Saturday",
    type: "string",
  },
  {
    id: "gateHoursSunday",
    name: "gateHoursSunday",
    label: "Gate Hours Sunday",
    type: "string",
  },
  {
    id: "ownerName",
    name: "ownerName",
    label: "Owner Name",
    type: "string",
  },
];

export const colClassMap: Record<string, string> = {
  address: "col-12 md:col-6 px-1",
  address2: "col-12 md:col-6 px-1",
  zipCode: "col-12 md:col-6 px-1",
  state: "col-12 md:col-2 px-1",
  city: "col-12 md:col-4 px-1",
  email: "col-12 md:col-6 px-1",
  phone: "col-12 md:col-6 px-1",
  ownerName: "col-12 md:col-6 px-1",
};

export const allowedFields = [
  "locationName",
  "address",
  "address2",
  "city",
  "state",
  "zipCode",
  "email",
  "phone",
  "hoursWeekdays",
  "hoursSaturday",
  "hoursSunday",
  "gateHours",
  "gateHoursSaturday",
  "gateHoursSunday",
  "ownerName",
];
